import { browserHistory, match } from "react-router";
import routes from "../routes";
import { syncHistoryWithStore } from "react-router-redux";
import { trigger } from "redial";

const setupRouteChangeListener = store => {
  const history = syncHistoryWithStore(browserHistory, store);
  history.listen(location => {
    match(
      { routes, location },
      (error, redirectLocation, { components, location, params }) => {
        const { pathname: path, query } = location;
        const { dispatch } = store;

        const locals = {
          store,
          path,
          query,
          params,
          location,
          dispatch
        };

        trigger("fetch", components, locals);
        trigger("defer", components, locals);
      }
    );
  });

  return history;
};

export default setupRouteChangeListener;
